import { useState } from "react";
import styled from "styled-components";
import { formatLocalDate, getMonthGrid, getMonthName } from "utilities/dateAndTime";
import { MaterialIcon } from "../shared/MaterialIcon";

export const Datepicker = ({date = new Date(), onChange}) => {

    const today = new Date();
    const selectedDate = new Date(date);

    const monthDiff = (selectedDate.getFullYear() - today.getFullYear()) * 12 + (selectedDate.getMonth() - today.getMonth());

    const [selectedMonth, setSelectedMonth] = useState(monthDiff);

    const newDate = new Date(today.getFullYear(), today.getMonth() + selectedMonth, 1);

    const monthGrid = getMonthGrid({month: newDate.getMonth(), year: newDate.getFullYear()});

    return (
        <StyledDatepicker>
            <div className="datepickerHeader">
                <MaterialIcon
                    name='keyboard_arrow_left'
                    weight={300}
                    onClick={() => {setSelectedMonth(prev => prev-1)}}
                />
                {getMonthName(newDate) + ' (' + newDate.getFullYear() + ')'}
                <MaterialIcon
                    name='keyboard_arrow_right'
                    weight={300}
                    onClick={() => {setSelectedMonth(prev => prev+1)}}
                />
            </div>
            <div className="datepickerContent">
                {
                    monthGrid.map((week, i) =>
                        <DatepickerWeek
                            week={week}
                            key={i}
                        >
                            {
                                week.map((day, i) =>
                                    <DatepickerDay
                                        key={i}
                                        day={day}
                                        selectedDate={date}
                                        onChange={onChange}
                                    />
                                )
                            }

                        </DatepickerWeek>
                    )
                }
            </div>
            
        </StyledDatepicker>
    )
}

const StyledDatepicker = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({theme}) => theme.spacing.md};
    align-items: center;

    div.datepickerHeader
    {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: ${({theme}) => theme.fontSize.md};
        gap: ${({theme}) => theme.spacing.md};
        font-weight: 600;

        .icon
        {
            cursor: pointer;
        }
    }

    div.datepickerContent
    {
        display: flex;
        flex-direction: column;
        gap: ${({theme}) => theme.spacing.sm};
    }
`

const DatepickerWeek = ({week, children}) => {

    return (
        <StyledDatepickerWeek>
            {children}    
        </StyledDatepickerWeek>
    )
}

const StyledDatepickerWeek = styled.div`
    display: flex;
    gap: ${({theme}) => theme.spacing.sm};
`

const DatepickerDay = ({day, selectedDate, onChange}) => {
    
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const isToday = formatLocalDate(day.date) === formatLocalDate(today);
    const isSelected = formatLocalDate(day.date) === formatLocalDate(new Date(selectedDate));

    return (
        <StyledDatepickerDay
            onClick={() => {if(day.isInMonth) onChange?.(day.date)}}
            className={isSelected ? 'isSelected' : isToday ? "isToday" : !day.isInMonth ? 'outsideMonth' : day.isWeekend ? 'isWeekend' : null}
        >
            {day.date.getDate()}
        </StyledDatepickerDay>
    )
}

const StyledDatepickerDay = styled.div`
    width: 26px;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
    border-radius: ${({theme}) => theme.cornerRadius.sm};
    transition-duration: 110ms;

    &:hover
    {
        background: ${({theme}) => theme.colors.neutralPrimaryBorder}
    }

    &.isSelected
    {
        background: ${({theme}) => theme.colors.neutralSecondaryForeground};
        color: ${({theme}) => theme.colors.neutralPrimaryBackground};

        &:hover
        {
            background: ${({theme}) => theme.colors.neutralSecondaryForeground};
        }
    }

    &.isToday
    {
        border: 1px solid ${({theme}) => theme.colors.neutralSecondaryForeground};
    }

    &.outsideMonth
    {
        opacity: 0.65;
        border: none;
        cursor: default;

        &:hover
        {
            background: none;
        }
    }

    &.isWeekend
    {
        color: ${({theme}) => theme.colors.errorForeground};
    }
`